import React from 'react';
import './EditorEntityPicker.less';
import { getEditorValidationSummary } from 'utils/ValidationUtils';
import { EditorConfigButton } from '../EditorConfigButton';
import { EditorConfigButtons } from '../EditorConfigButtons';
import { TextField } from 'components/inputs/TextField';
import { EditorLabel } from '../EditorLabel';
import { IPropertyChild } from 'components/property-editors/utils/ProviderNodeUtils';
import { useEditorId } from '../hooks/useEditorId';

export interface IEntityPickerWithLinks {
  editor: IPropertyChild;
  path: string[];
  hideInputLabel: boolean | undefined;
  onDrop?: () => void;
  entityName: string;
  onPickClick?: () => void;
  onCreateClick?: () => void;
  onEditClick?: () => void;
}

export function EntityPickerWithLinks({
  editor,
  path,
  hideInputLabel,
  onDrop,
  entityName,
  onCreateClick,
  onEditClick,
  onPickClick,
}: IEntityPickerWithLinks) {
  const validation = getEditorValidationSummary(editor);
  const [id] = useEditorId(path);
  return (
    <EditorLabel htmlFor={id} editor={editor} path={path} doNotWrap hideInputLabel={hideInputLabel}>
      <div className="dpc-editor-epick">
        <TextField disabled onClear={onDrop} showClear value={entityName} validation={validation} />
        <EditorConfigButtons>
          {onPickClick && <EditorConfigButton onClick={onPickClick}>Pick</EditorConfigButton>}
          {onCreateClick && <EditorConfigButton onClick={onCreateClick}>Create</EditorConfigButton>}
          {onEditClick && <EditorConfigButton onClick={onEditClick}>Edit</EditorConfigButton>}
        </EditorConfigButtons>
      </div>
    </EditorLabel>
  );
}
